import { useState } from "react";
import { GetCoursesByStudentEmail } from "../../actions/teacherQueries";
import Pacmanloader from "../Pacmanloader/Pacmanloader";
import ResultTable from "../Results/ResultTable";
import StatusBadge from "../Badges/StatusBadge";
import moment from "moment";
import { FormattedMessage, injectIntl } from "react-intl";
import { Button } from "reactstrap";
import StudentResultQuestionOverview from "../Results/StudentResultQuestionOverview";
import { getWinOptions } from "../../Utilities/moduleHelper";
import { LW_COURSE_API_URL } from "../../constants/api.constants";
import "moment/locale/sv";

function StudentResultOverview({
  studentEmail,
  studentId,
  coursesWithResults,
  intl,
}) {
  const studentCourses = GetCoursesByStudentEmail(studentEmail);
  const [moduleId, setModuleId] = useState(null);
  const [courseId, setCourseId] = useState(null);
  const [moduleName, setModuleName] = useState(null);
  const [courseName, setCourseName] = useState(null);
  const [variantId, setVariantId] = useState(null);
  const [latestResultIsOpen, setLatestResultIsOpen] = useState(true);
  const toggleLatest = () => setLatestResultIsOpen(!latestResultIsOpen);
  const [bestResultIsOpen, setBestResultIsOpen] = useState(true);
  const toggleBest = () => setBestResultIsOpen(!bestResultIsOpen);
  moment.locale("sv");

  const viewAt2Result = (studentEmail, currentCourseId, currentModuleId) => {
    var winOptions = getWinOptions;
    window.open(
      `${LW_COURSE_API_URL}/Home/ViewModuleResult?` +
        "email=" +
        encodeURIComponent(studentEmail) +
        "&courseId=" +
        currentCourseId +
        "&moduleId=" +
        currentModuleId,
      "",
      winOptions
    );
  };
  const viewScormResult = (courseId, moduleId, courseName, moduleName) => {
    setModuleId(moduleId);
    setCourseId(courseId);
    setModuleName(moduleName);
    setCourseName(courseName);
    setVariantId(null);
    setBestResultIsOpen(true);
    setLatestResultIsOpen(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  const viewGy25FinalExamResult = (
    courseId,
    moduleId,
    courseName,
    variantName,
    variantId
  ) => {
    setModuleId(moduleId);
    setCourseId(courseId);
    setModuleName(variantName);
    setCourseName(courseName);
    setVariantId(variantId);
    setBestResultIsOpen(true);
    setLatestResultIsOpen(true);
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (studentCourses.isLoading) {
    return <Pacmanloader />;
  }

  const columnExtensions = [
    { columnName: "name", width: 280 },
    { columnName: "showResult", width: 130 },
    { columnName: "status", width: 180 },
    { columnName: "donePercentage", width: 150 },
    { columnName: "score", width: 170 },
    { columnName: "nbrOfAttempts", width: 130 },
    { columnName: "activityPoints", width: 170 },
    { columnName: "lastRun", width: 200 },
  ];

  const columns = [
    { title: <FormattedMessage id="Name" />, name: "name" },
    { title: <FormattedMessage id="ShowResult" />, name: "showResult" },
    { title: <FormattedMessage id="Status" />, name: "status" },
    { title: <FormattedMessage id="PercentDone" />, name: "donePercentage" },
    { title: <FormattedMessage id="ModuleTestScore" />, name: "score" },
    {
      title: <FormattedMessage id="NumberOfAttempts" />,
      name: "nbrOfAttempts",
    },
    { title: <FormattedMessage id="ActivityPoints" />, name: "activityPoints" },
    { title: <FormattedMessage id="LastRun" />, name: "lastRun" },
  ];

  let tableData = [];
  studentCourses.data.forEach((c) => {
    let lastRun = c.modules.some((mod) => mod.lastRun != null)
      ? new Date(
          Math.max(...c.modules.map((e) => new Date(e.lastRun)))
        ).toString()
      : null;
    let course = {
      id: "c" + c.id,
      parentId: null,
      name: c.name,
      status: <StatusBadge status={c.status} />,
      donePercentage: c.progressPercentage,
      lastRun: lastRun === null ? null : moment(lastRun).format("lll"),
    };
    tableData.push(course);
    let sortedModules = c.modules.sort((a, b) => {
      return a.sortOrder - b.sortOrder;
    });

    sortedModules.forEach((m) => {
      let module = {};
      const isGy25FinalExam = m.isGy25 && m.isFinalExam;
      let gy25FinalExamStatus = null;
      if (isGy25FinalExam) {
        let currentModule = coursesWithResults
          .find((course) => course.id === c.id)
          ?.modules?.find((module) => module.moduleId === m.id);

        if (currentModule) {
          gy25FinalExamStatus = currentModule.students?.find(
            (stud) => stud.studentId === Number(studentId)
          );
        }
      }
      if (
        isGy25FinalExam &&
        gy25FinalExamStatus != null &&
        gy25FinalExamStatus.finalExamVariants.length > 1
      ) {
        module = {
          id: "m" + m.id,
          parentId: "c" + c.id,
          name: m.name,
          status: null,
          statusCode: null,
          score: null,
          nbrOfAttempts: null,
          activityPoints: null,
          lastRun: null,
          showResult: (
            <FormattedMessage
              values={{
                count: gy25FinalExamStatus.finalExamVariants.length,
              }}
              id="MultipleExamsNumberOfExams"
            />
          ),
          activityPointsPercentage: null,
          scorePercentage: null,
          isGy25FinalExam: null,
        };
      } else {
        if (m.isGy25 && !m.isFactModule && !m.isFinalExam) return;

        const isGy25FactModule = m.isGy25 && m.isFactModule && !m.isFinalExam;

        let coupledTestMod = null;

        if (isGy25FactModule) {
          coupledTestMod = c.modules.find(
            (s) =>
              s.moduleCoupleId === m.moduleCoupleId &&
              s.id !== m.id &&
              s.isGy25 &&
              !s.isFactModule &&
              !s.isFinalExam
          );
        }

        const hasFinalExamStatus =
          isGy25FinalExam && gy25FinalExamStatus != null;
        const hasCoupledTestMod = isGy25FactModule && coupledTestMod != null;

        const getStatusBadge = () => {
          return hasFinalExamStatus ? (
            <StatusBadge
              status={gy25FinalExamStatus.status}
              isGy25FinalExam={true}
            />
          ) : hasCoupledTestMod && coupledTestMod.status != null ? (
            <>
              <StatusBadge
                status={m.status}
                title={intl.formatMessage({ id: "StatusForFactModule" })}
              />
              <StatusBadge
                status={coupledTestMod.status}
                title={intl.formatMessage({ id: "StatusForTestModule" })}
                isTestModule={true}
              />
            </>
          ) : (
            <StatusBadge status={m.status} />
          );
        };

        const moduleScore = hasFinalExamStatus
          ? gy25FinalExamStatus.score
          : hasCoupledTestMod && coupledTestMod.score != null
          ? coupledTestMod.score
          : m.score;

        const moduleMaxScore = hasFinalExamStatus
          ? gy25FinalExamStatus.maxScore
          : hasCoupledTestMod && coupledTestMod.maxScore != null
          ? coupledTestMod.maxScore
          : m.maxScore;

        const getModuleScore = () => {
          if (moduleScore == null) return 0;

          const roundedScore = Math.round(moduleScore * 100) / 100;

          if (!moduleMaxScore || moduleMaxScore <= 0) {
            return roundedScore;
          }

          const percentage = hasFinalExamStatus
            ? gy25FinalExamStatus.scoreInPercent
            : hasCoupledTestMod && coupledTestMod.score != null
            ? coupledTestMod.scoreInPercent
            : m.scoreInPercent;

          return `${roundedScore}/${moduleMaxScore} (${percentage}%)`;
        };

        const getNbrOfAttempt = () => {
          return hasCoupledTestMod && coupledTestMod.nbrOfAttempts > 0
            ? coupledTestMod.nbrOfAttempts
            : m.nbrOfAttempts > 0
            ? m.nbrOfAttempts
            : null;
        };

        const getActivityPoints = () => {
          if (isGy25FinalExam) return null;

          if (m.activityPoints != null && m.maxActivityPoints != null) {
            const percentage =
              m.maxActivityPoints > 0
                ? Math.round((m.activityPoints / m.maxActivityPoints) * 100)
                : 0;
            return `${m.activityPoints}/${m.maxActivityPoints} (${percentage}%)`;
          }

          return 0;
        };

        const getLastRun = () => {
          if (hasFinalExamStatus && gy25FinalExamStatus.lastRun != null) {
            return moment(gy25FinalExamStatus.lastRun).format("lll");
          }

          if (hasCoupledTestMod && coupledTestMod.lastRun != null) {
            return moment(coupledTestMod.lastRun).format("lll");
          }

          if (m.lastRun != null) {
            return moment(m.lastRun).format("lll");
          }

          return null;
        };

        const showResultButton = () => {
          const shouldShowBtn =
            (hasCoupledTestMod && coupledTestMod.status !== "NotStarted") ||
            (!m.isGy25 && !m.isFactModule && m.status !== "NotStarted");

          if (!shouldShowBtn) return null;

          return (
            <Button
              className="btn-sm"
              color="primary"
              outline
              onClick={
                m.moduleType === 1
                  ? () => viewAt2Result(studentEmail, c.id, m.id)
                  : () =>
                      viewScormResult(
                        c.id,
                        coupledTestMod?.id || m.id,
                        c.name,
                        m.name
                      )
              }
            >
              <FormattedMessage id="ShowResult" />
            </Button>
          );
        };

        const getScorePercentage = () => {
          if (
            hasCoupledTestMod &&
            coupledTestMod.score != null &&
            coupledTestMod.maxScore > 0
          ) {
            return Math.round(
              (coupledTestMod.score / coupledTestMod.maxScore) * 100
            );
          }

          if (m.score != null && m.maxScore > 0) {
            return Math.round((m.score / m.maxScore) * 100);
          }

          return 0;
        };

        module = {
          id: "m" + m.id,
          parentId: "c" + c.id,
          name: m.name,
          status: getStatusBadge(),
          statusCode:
            hasCoupledTestMod && coupledTestMod.status != null
              ? coupledTestMod.status
              : m.status,
          score: getModuleScore(),
          nbrOfAttempts: getNbrOfAttempt(),
          activityPoints: getActivityPoints(),
          lastRun: getLastRun(),
          showResult: showResultButton(),
          activityPointsPercentage:
            m.activityPoints != null && m.maxActivityPoints > 0
              ? Math.round((m.activityPoints / m.maxActivityPoints) * 100)
              : 0,
          scorePercentage: getScorePercentage(),
          isGy25FinalExam: isGy25FinalExam,
        };
      }
      tableData.push(module);
      if (isGy25FinalExam && gy25FinalExamStatus != null) {
        gy25FinalExamStatus.finalExamVariants
          .sort((a, b) => new Date(b.lastRun) - new Date(a.lastRun))
          .forEach((variant) => {
            let variantToAdd = {
              id: "variant" + variant.variantId,
              parentId: "m" + m.id,
              name: variant.name,
              status: (
                <StatusBadge status={variant.status} isGy25FinalExam={true} />
              ),
              statusCode: 0,
              score:
                variant.score != null
                  ? `${variant.score} (${variant.scoreInPercent}%)`
                  : "",
              nbrOfAttempts: variant.lastRun == null ? "-" : 1,
              activityPoints: null,
              lastRun:
                variant.lastRun != null
                  ? moment(variant.lastRun).format("lll")
                  : null,
              showResult:
                variant.status !== "NotStarted" ? (
                  <Button
                    className="btn-sm"
                    color="primary"
                    outline
                    onClick={() =>
                      viewGy25FinalExamResult(
                        c.id,
                        m.id,
                        c.name,
                        variant.name,
                        variant.variantId
                      )
                    }
                  >
                    <FormattedMessage id="ShowResult" />
                  </Button>
                ) : null,
              activityPointsPercentage: "-",
              scorePercentage: variant.scoreInPercent,
            };

            tableData.push(variantToAdd);
          });
      }
    });
  });

  return (
    <div>
      <StudentResultQuestionOverview
        studentId={studentId}
        courseId={courseId}
        moduleId={moduleId}
        moduleName={moduleName}
        courseName={courseName}
        bestResultIsOpen={bestResultIsOpen}
        toggleBest={toggleBest}
        latestResultIsOpen={latestResultIsOpen}
        toggleLatest={toggleLatest}
        isGy25FinalExam={variantId != null}
        variantId={variantId}
      />
      <ResultTable
        level="Student"
        tableData={tableData}
        columnExtensions={columnExtensions}
        columns={columns}
      />
    </div>
  );
}

export default injectIntl(StudentResultOverview);
